module.exports = __webpack_public_path__ + "static/media/user-15.0f720aca.png";